<template>
    <div class="main bbt-main bbt-main">
        <div class="btm-banner banner-index swiper-container swiper-container-initialized swiper-container-horizontal">
            <el-carousel height="630px">
                <el-carousel-item v-for="item in bigCover" :key="item.id">
                    <div class="img-box" :style="{backgroundImage: `url(${item.bigCover})`}">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="books-module" style="background-color: rgb(255, 255, 255);">
            <div class="bbt-container">
                <h2>出版图书</h2>
                <div class="book-module">
                    <div class="bbt-row" style="margin-left: -12px; margin-right: -12px;">
                        <el-row type="flex" justify="space-between" :gutter="25" v-for="book in bookList" :key="book">
                            <el-col :xl="8" :lg="7" :md="6" :sm="24" v-for="item in book" :key="item.id">
                                <div class="book-item bbt-clearfix">
                                    <div class="book-item__thumb">
                                        <router-link :to="{path:'/book_detail/' + item.id}" target="_blank">
                                            <el-image
                                            class="img-full"
                                            :src="item.bookCover"
                                            :fit="cover"></el-image>
                                        </router-link>
                                    </div>

                                    <div class="book-item__body">
                                        <div class="book-item__title">
                                            <router-link :to="{path:'/book_detail/' + item.id}" class="link-dark-major font-bold" target="_blank">
                                                {{item.bookName}}
                                            </router-link>
                                        </div>
            
                                        <div class="book-item__desc">
                                            {{item.descriptions}}
                                        </div>
                                        <div class="book-item__author">
                                            <span class="author_name">
                                                作者:
                                                <span>{{item.authors.length > 13 ? item.authors.substr(0, 13) + '...' : item.authors}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    
                    <el-row type="flex" justify="center">
                        <!-- <div class="bbt-col-xs-24" style="padding-left:12px;padding-right:12px;">
                            <div class="bbt-btn bbt-btn--default bbt-btn--lg bbt-btn-block" @click="loadMoreArticle" v-if="hasMoreArticle">
                                查看更多
                            </div>
                        </div> -->
                        <el-button type="danger" plain  @click="loadMoreArticle" v-if="hasMoreArticle" style="width:45%">查看更多</el-button>
                    </el-row>
                </div>
                <!-- <div class="books-module__more">
                    <a href="javascript:;" class="bbt-btn bbt-btn--primary bbt-btn-lg" style="width: 244px; padding: 16px 15px;">查看更多</a>
                </div> -->
            </div>
        </div>

        <div class="plan-module" :style="{background: `url(${publicPath}default/shazhishu@2x.webp) center center / cover no-repeat rgb(51, 51, 51)`}">
            <div class="bbt-container">
                <h2>“沙之书”2.0 开放翻译计划</h2>
                <p class="plan-module__desc">
                    <i class="quote0 bbt-icon bbt-icon-quote" style="font-size: 28px;"></i>
                    这本书的页码是无穷尽的。没有首页，也没有末页。我不明白为什么要用这种荒诞的编码办法。也许是想说明一个无穷大的系列允许任何数项的出现。——博尔赫斯《沙之书》
                    <i class="quote1 bbt-icon bbt-icon-quote" style="font-size: 28px;"></i>
                </p>
                <div class="bbt-clearfix" style="padding: 0px 200px;">
                    <div class="bbt-col-xs-8">
                        <div class="plan-module__item">
                            <i class="bbt-icon bbt-icon-infinitybook-0" style="color: rgb(255, 255, 255); font-size: 40px;"></i>
                            <p>同步译介最新国外区块链&amp;<br>数字货币社区讨论</p>
                        </div>
                    </div>
                    <div class="bbt-col-xs-8">
                        <div class="plan-module__item">
                            <i class="bbt-icon bbt-icon-infinitybook-1" style="color: rgb(255, 255, 255); font-size: 40px;"></i>
                            <p>介绍最新区块链软件<br>与应用开发动态</p>
                        </div>
                    </div>
                    <div class="bbt-col-xs-8">
                        <div class="plan-module__item">
                            <i class="bbt-icon bbt-icon-infinitybook-2" style="color: rgb(255, 255, 255); font-size: 40px;"></i>
                            <p>公平开放的引入对区块链<br>正面或负面的评价</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="plan-module__more">
                    <a target="_blank" href="https://www.chainnode.com/post/507" class="bbt-btn bbt-btn--primary bbt-btn-lg" style="width: 244px; padding: 16px 15px;">了解更多</a>
                </div> -->
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name:'MoreBook',
    props: {
        serveHost: String
    },
    data () {
        return {
            publicPath: process.env.BASE_URL,
            hasMoreArticle:true,
            pagNo:1,
            bookList:[],
            bigCover: []
        }
    },
    methods:{
        loadMoreArticle:function() {
            // 文章列表更多加载
            this.pagNo++
            this.loadArticleList(this);
        },
        loadArticleList:function(_vm) {
            // 帖子列表
            $.get(_vm.serveHost + '/api/v1/book/list', {
                pagNo: _vm.pagNo
            },function(r){
                if(r.code != "2000000") {
                    console.error('get post list error.');
                }
                if(r.data) {
                    if(r.data.length < 3) {
                        _vm.hasMoreArticle = false;
                    }
                    var a = [];
                    for(let i = 0;i <= r.data.length;i++) {
                        if(i % 3 == 0 && i != 0) {
                            if(a.length > 0) {
                                _vm.bookList.push(a);
                            }
                            a = [];
                        } 
                        a.push(r.data[i]);
                    }
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasMoreArticle = false;
                    _vm.$alert('没有更多图书了', '提示', {
                        type:'warning',
                        closeOnClickModal:true,
                        closeOnPressEscape:true,
                        confirmButtonText: '确定',
                        callback: action => {
                            
                        }
                    });
                }
            });
        }
    },
    created() {
        var _vm = this;
        this.loadArticleList(this);

        $.get(_vm.serveHost + '/api/v1/book/cover', (r) => {
            // console.log(r);
            if(r.data.length > 0) {
                _vm.bigCover = r.data;
            }
            
        });
    }
}
</script>

<style scoped>
.bbt-btn.bbt-btn--primary {
    color: #fff;
    background: #e00;
    border-color: #e00;
    transition: all .3s ease;
}
.bbt-btn {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 14px;
    font-weight: 500;
    padding: 9px 15px;
    line-height: 1;
    border: 1px solid transparent;
    background: none;
    border-radius: 4px;
    outline: none;
}
.plan-module__more {
    text-align: center;
    margin-top: 36px;
}
.plan-module__item p {
    margin: 0;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    margin-top: 12px;
}
.plan-module__item {
    margin: 62px 0 12px;
    text-align: center;
}
.bbt-col-xs-8 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333333%;
}
.plan-module__desc .quote1 {
    position: absolute;
    bottom: -6px;
    right: -36px;
    text-align: right;
    color: #e00;
}
.plan-module__desc .quote0 {
    position: absolute;
    top: -6px;
    left: -36px;
    text-align: left;
    transform: rotate(180deg);
    color: #e00;
}
.bbt-icon {
    line-height: 1;
    font-size: 14px;
}
.plan-module__desc {
    width: 876px;
    color: #fff;
    font-size: 18px;
    line-height: 26px;
    line-height: 38px;
    text-align: center;
    position: relative;
    margin: 0 auto;
}
.plan-module h2 {
    margin: 0 0 40px;
    text-align: center;
    font-size: 36px;
    line-height: 44px;
    line-height: 38px;
    color: #fff;
    font-weight: 700;
}
.plan-module {
    padding: 96px 0;
}
.author_name span {
    font-weight:700;
}
.author_name {
    display:block;
    color:#5c5c5c;
    font-size:12px;
    margin-bottom:10px;
}
.link-dark-major:hover {
    color:#e00;
}
.book-item:hover .book-item__thumb img{
    margin-top:-10px;
}
.book-item__author .bbt-avatar {
    bottom: 24px;
    margin-right: 8px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
}
.bbt-avatar.bbt-avatar--sm {
    max-width: 32px!important;
    width: 32px!important;
    height: 32px!important;
}
.bbt-avatar {
    border-radius: 50%;
    vertical-align: middle;
}
.font-bold, .font-medium {
    font-weight: 700;
}
.link-dark-major {
    color: rgba(0,0,0,.88);
    transition: all .3s ease;
}
.book-item__author {
    position: absolute;
    left: 188px;
    bottom: 24px;
}
.book-item__desc {
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.56);
    height: 80px;
    overflow: hidden;
}
.book-item__title {
    max-height: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.88);
    margin-bottom: 8px;
}
.book-item__thumb img {
    border-radius: 4px;
    min-height: 215px;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
    transition: all .3s ease;
}
.img-full {
    display: block;
    width: 100%;
    height: auto;
}
.book-item__thumb {
    margin-top: -40px;
    float: left;
    width: 148px;
    height: 215px;
    margin-right: 16px;
}
.book-item {
    margin-bottom: 24px;
    margin-top: 16px;
    padding: 16px 24px 24px;
    background: #fff;
    border-radius: 4px;
    position: relative;
    border: 1px solid rgba(0,0,0,.08);
}
.bbt-col-xs-8 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333333%;
}
.bbt-btn.bbt-btn--primary {
    color: #fff;
    background: #e00;
    border-color: #e00;
    transition: all .3s ease;
}

.bbt-btn {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 14px;
    font-weight: 500;
    padding: 9px 15px;
    line-height: 1;
    border: 1px solid transparent;
    background: none;
    border-radius: 4px;
    outline: none;
}
.books-module__more {
    text-align: center;
    margin-top: 36px;
}
.books-module h2 {
    text-align: center;
    color: rgba(0,0,0,.88);
    font-size: 36px;
    line-height: 44px;
    line-height: 38px;
    margin: 0 0 80px;
}
.books-module {
    padding: 96px 0;
}
.banner-index .img-box {
    height: 630px;
    background-size: cover;
    text-align: center;
    background-position: top;
    background-repeat: no-repeat;
}
.banner-index {
    width: 100%;
    height: 630px;
}
.swiper-container {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}
</style>